export interface ValidationErrorDetail {
  loc: (string | number)[];
  msg: string;
  type: string;
}

export interface HTTPValidationError {
  detail?: ValidationErrorDetail[];
}

export interface HTTPErrorBody {
  error?: string;
  detail?: string | ValidationErrorDetail[];
}

export class ApiError extends Error {
  status: number;
  body: unknown;
  validation: ValidationErrorDetail[] | null;

  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
    this.validation =
      body && typeof body === 'object' && 'detail' in (body as any) && Array.isArray((body as any).detail)
        ? ((body as any).detail as ValidationErrorDetail[])
        : null;
  }
}

export function formatApiError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.validation && err.validation.length) {
      return err.validation
        .map((d) => `${d.loc.join('.')}: ${d.msg}`)
        .join('; ');
    }
    if (err.body && typeof err.body === 'object') {
      const b = err.body as HTTPErrorBody;
      if (typeof b.error === 'string') return b.error;
      if (typeof b.detail === 'string') return b.detail;
    }
    return err.message || `HTTP ${err.status}`;
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
